// https://github.com/alphagov/govuk-frontend/blob/master/src/components/table/_table.scss

import styled from 'styled-components';

const TableHeader = styled('thead')({});

export default TableHeader;
